import React, { ComponentProps, useEffect, useRef, useState } from 'react';

export type CountDownLinkProps = ComponentProps<'span'> & {
  countdownSeconds: number;
};

const CountDownLink = ({ countdownSeconds, children, onClick, ...props }: CountDownLinkProps) => {
  const intervalIDRef = useRef<NodeJS.Timer | null>(null);
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  const handleOnClickLink: React.MouseEventHandler<HTMLElement> = (event) => {
    if (intervalIDRef.current) clearInterval(intervalIDRef.current);
    setRemainingSeconds(countdownSeconds);
    const intervalId = setInterval(
      () => setRemainingSeconds((prev) => (prev > 0 ? prev - 1 : prev)),
      1000
    );
    intervalIDRef.current = intervalId;
    onClick?.(event);
  };

  useEffect(() => {
    return () => {
      if (intervalIDRef.current) clearInterval(intervalIDRef.current);
    };
  }, [intervalIDRef, countdownSeconds]);

  if (remainingSeconds) {
    return (
      <span {...props}>
        {children}
        <span className="countDownLink-remainingTime">{`(${remainingSeconds}s)`}</span>
      </span>
    );
  }

  return (
    <span className="countDownLink" {...props} onClick={handleOnClickLink}>
      {children}
    </span>
  );
};

export default CountDownLink;
